import React from 'react';

import { Label } from './styled';

export interface IBaseSwitcherProps {
    id?: string,
    name?: string,
    value?: string,
    checked?: boolean,
    disabled?: boolean,
    required?: boolean,
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, state?: boolean) => void,
    className?: string,
    [key: string]: unknown,
}

/**
 * Компонент свича для отображения без внутреннего состояния (что пришло, то кажем!)
 */
const SimpleBaseSwitcher = ({
    id,
    name = '',
    value = '',
    checked,
    disabled = false,
    required,
    children,
    onChange,
    className,
    ...props
}: IBaseSwitcherProps): JSX.Element => {
    return (
        <Label
            checked={checked}
            disabled={disabled}
            className={className}
            {...props}
        >
            <input
                type='checkbox'
                id={id}
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                required={required}
                onChange={onChange}
                data-test={'UncontrollableSwitcher'}
            />
            {children}
        </Label>
    );
};

export default SimpleBaseSwitcher;
